import React from 'react';
import { ClockIcon } from 'lucide-react';
import { Button } from './Button';
import { formatPrice } from '../utils/currency';
import type { Reading } from '../types/content';
type ReadingCardProps = {
  reading: Reading;
  onBook?: (id: Reading['id']) => void;
  headingLevel?: 'h3' | 'h2';
};
export function ReadingCard({
  reading,
  onBook,
  headingLevel = 'h3'
}: ReadingCardProps) {
  const Heading = headingLevel;
  const featured = Boolean(reading.badge);
  return <article className={`flex h-full flex-col p-[clamp(1.75rem,2.4vw,3rem)] ${featured ? 'bg-cream ring-1 ring-gold' : 'bg-white ring-1 ring-stone'}`} data-id="element-375" data-mp="2cltae34pdrrt">
      <div className="flex min-h-[2rem] items-center justify-between gap-4" data-id="element-376" data-mp="2qmdsex2snjk9">
        <span className="t-numeral text-lg text-gold-deep" data-id="element-377" data-mp="2mjr6fcst0suz">{reading.numeral}</span>
        {reading.badge && <span className="t-label border border-gold-deep px-2.5 py-1 text-[0.6rem] text-gold-deep" data-id="element-378" data-mp="5uloc28ri8nw">{reading.badge}</span>}
      </div>
      <Heading className="t-h3 mt-8" data-id="element-379" data-mp="1ticrrxqyysh">{reading.name}</Heading>
      <p className="t-label mt-2 text-[0.66rem] text-graphite" data-id="element-380" data-mp="1hzufw8snxq83">{reading.tagline}</p>
      <p className="mt-6 text-graphite" data-id="element-381" data-mp="1mxw395x4gbpd">{reading.description}</p>
      {reading.note && <p className="mt-3 text-sm italic text-graphite" data-id="element-382" data-mp="1qzpxavctahgk">{reading.note}</p>}
      <div className="mt-auto pt-10" data-id="element-383" data-mp="1r0itj2e59okg">
        <div className="flex items-end justify-between gap-4 border-t border-stone pt-6" data-id="element-384" data-mp="1vyke5rr7xvy1">
          <div data-id="element-385" data-mp="z8jqjw2l5lib">
            <p className="flex items-center gap-2 text-sm text-graphite" data-id="element-386" data-mp="z93afibsqjyz">
              <ClockIcon aria-hidden="true" strokeWidth={1.25} className="h-4 w-4" data-id="element-387" data-mp="13a51vczh1rqe" /> {reading.duration}
            </p>
            <p className="mt-1 text-sm text-graphite" data-id="element-388" data-mp="188q41hyaalhh">{reading.prep}</p>
          </div>
          <p className="text-[clamp(1.6rem,1.3rem+0.8vw,2.25rem)] font-light leading-none text-charcoal" data-id="element-389" data-mp="1czolikv0dpmb">{formatPrice(reading.price)}</p>
        </div>
        {onBook ? <Button onClick={() => onBook(reading.id)} variant={featured ? 'solid' : 'outline'} className="mt-6 w-full" aria-label={`Book ${reading.name}`} data-id="element-390" data-mp="fihs47uccxbc">
            Book Now
          </Button> : <Button to={`/readings?type=${reading.id}#book`} variant={featured ? 'solid' : 'outline'} className="mt-6 w-full" data-id="element-391" data-mp="1ns8a9gkxrrya">
            Book Now<span className="sr-only" data-id="element-392" data-mp="1wnel4tz2d07o">: {reading.name}</span>
          </Button>}
      </div>
    </article>;
}